import React from 'react';
import { useSelector } from 'react-redux';

import { getL1CategoryIdBySeoName } from '@gumtree/shared/src/util/category-mapping';

import type { ImageSlide, VideoSlide } from '@gumtree/ui-library/src/carousel/slider';

import CarouselGallery from '../carousel-gallery/index.container';

import ThreeImageThumbnailGallery from './three-image-thumbnail-gallery';
import { VipState } from '../../reducers';

export const VipGallery: React.FC<{}> = () => {
    const {
        images = [],
        video = { urls: [] },
        baseConfig = { device: { type: 'desktop' } },
        adDetails = { l1Category: 0 },
    } = useSelector((state: VipState) => state);

    const videoUrl = video?.urls?.[0] || '';
    const deviceType = baseConfig?.device?.type || 'desktop';
    
    const isInCategory =
        adDetails.l1Category === getL1CategoryIdBySeoName('for-sale') ||
        adDetails.l1Category === getL1CategoryIdBySeoName('cars-vans-motorbikes');

    const noMedia = !videoUrl && images.length === 0;
    const showVideoOnly = videoUrl && images.length === 0;
    const showThreeImageGallery = images.length >= 3 && deviceType !== 'desktop' && isInCategory;
    const mediaArray = videoUrl
        ? ([
              ...images.map((image) => ({ type: 'image', link: image })),
              { link: videoUrl, type: 'video' },
          ] as (ImageSlide | VideoSlide)[])
        : (images.map((image) => ({ type: 'image', link: image })) as ImageSlide[]);
    const itemsShowing = mediaArray.length;

    return (
        <>
            {showVideoOnly ? (
                <CarouselGallery
                    mediaLinks={[{ link: videoUrl, type: 'video' }]}
                    hasCounterDots={false}
                />
            ) : showThreeImageGallery ? (
                <ThreeImageThumbnailGallery mediaLinks={mediaArray} itemsShowing={itemsShowing} />
            ) : (
                <>{noMedia ? null : <CarouselGallery mediaLinks={mediaArray} hasCounterDots />}</>
            )}
        </>
    );
};

export default VipGallery;
